export default "__VITE_ASSET__CZbxuiVx__"